import * as React from 'react';
import QrScanner from 'react-qr-barcode-scanner';

import { Gugle } from '../controllers';
import { TokenValidator } from '../utils';

const Main = () => {
  
  let init = React.useRef(false);
  const [completed , setCompleted] = React.useState(false);

  React.useEffect(() => {
    if(init.current){
      return;
    }

    init.current = true;

    handleCodeExtrac();
  });


  const handleCodeExtrac = async() => {
    let params = new URLSearchParams(document.location.search);
    let code = params.get("code"); 

    const response = await Gugle.GetAuthTokens(code);

    if(response === undefined){
      alert('No reponse from server');
      return;
    }

    if(response.tokens === undefined){
      alert(response.info);
      return;
    }
    
    setCompleted(true);

    window.close();
    console.log('closed');
  }

  return (
    <div>
      <h1>Saving information</h1>
      {completed && (
        <h2>Saving complete. You can close this window</h2>
      )}  
    </div>
  );
};

export default Main;
